import styled from '@emotion/styled';
import { typography, color } from 'styled-system';

const HeaderText = styled('h1')`
  margin-bottom: 0px;
  font-family: 'Nunito Sans';
  font-size: 20pt;
  color: ${({ theme }) => theme.colors.text};
  ${typography}
  ${color}
`;

export default HeaderText;
